import React, { useState } from 'react'
import { Controller, FormContext, useForm } from 'react-hook-form'
import PropTypes from 'prop-types'
import { Box, Paper, Typography } from '@material-ui/core'

import { BaseDialog, ButtonGroup } from 'components'

import helpers from 'helpers'

import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'
import schema from './schema'
import theme from 'theme'

const ResponsibleForm = ({
  ticket,
  refresh,
  userCompanies = [],
  setLoading = () => {},
  disabled = false,
  ...rest
}) => {
  const [openModal, setOpenModal] = useState(false)

  const snackbar = useSnackbar()
  const formMethods = useForm({
    validationSchema: schema,
    defaultValues: { responsibleId: ticket?.responsible?.id || null },
  })

  const { control, handleSubmit, watch } = formMethods

  const responsibleId = watch('responsibleId')

  const mountOptions =
    userCompanies?.map((item) => ({
      id: item?.user?.id,
      name: item?.user?.name,
    })) || []

  const responsible = mountOptions?.find(
    (option) => option?.id === responsibleId,
  )

  const handleOpenModal = () => setOpenModal((prevState) => !prevState)

  const onSubmit = async (data) => {
    try {
      setLoading(true)

      await service.dponet.titularTickets.update({
        ticketId: ticket?.id,
        ...data,
      })

      snackbar.open({
        message: 'Responsável registrado com sucesso!',
        variant: 'success',
      })
      refresh()
      handleOpenModal()
    } catch (error) {
      console.error(error)
      snackbar.open({
        message: helpers.formatters.errorMessage(error.response.data.error),
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <FormContext {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)} id="ticket-responsible-form">
        <Paper
          component={Box}
          py={2}
          px={3}
          display="flex"
          flexDirection="column"
          gridGap={theme.spacing(1)}
          {...rest}
        >
          <Typography variant="subtitle1" color="primary">
            Ticket: {ticket?.id}
          </Typography>
          <Controller
            as={
              <ButtonGroup
                options={mountOptions}
                title="ATRIBUIR PARA"
                controlName="responsibleId"
                tooltipPlacement="left"
                fullWidth
                onClick={handleOpenModal}
                typographyItemsProps={{ variant: 'body2' }}
                disabled={disabled}
              />
            }
            control={control}
            name="responsibleId"
          />
        </Paper>
        <BaseDialog
          open={openModal}
          setOpen={setOpenModal}
          title="Atribuir responsável para solicitação"
          actionButtonText="Confirmar"
          closeButtonText="Cancelar"
          formRef="ticket-responsible-form"
        >
          <Box p={1}>
            <Typography variant="body1" color="primary">
              Tem certeza de que deseja confirmar
              <strong> {responsible?.name} </strong>
              como o responsável pela solicitação?
            </Typography>
          </Box>
        </BaseDialog>
      </form>
    </FormContext>
  )
}

ResponsibleForm.propTypes = {
  ticket: PropTypes.object,
  setLoading: PropTypes.func.isRequired,
  userCompanies: PropTypes.array,
  disabled: PropTypes.bool,
}

export default ResponsibleForm
